import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { CONSTANTS } from '../static/constants';
import Copyright from './copyright';
const HeroSection = styled.section`
	display: flex;
	margin-bottom: 6rem;
	.title-section {
		width: 50%;
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-top: 10rem;
		@media (max-width:768px){
			width: 100%;
		}
	}
	.banner-section {
		width: 50%;
		position: relative;
		@media (max-width:768px){
			display: none;
		}
	}
	h1 {
		font-size: ${CONSTANTS.display1};
		color: ${CONSTANTS.primary};
		font-weight: 700;
		margin-bottom: 1rem;
	}
	span {
		font-size: ${CONSTANTS.body};
		color: ${CONSTANTS.darkergrey};
		display: block;
		font-weight: 500;
		margin-bottom: 2rem;
	}
`;

const BgImg = styled.img`
	width: 100%;
`;

const LetterTile = styled.div`
	padding: 1.4rem;
	border-radius: 16px;
	background: #FCFEFF;
	box-shadow: 1px 12px 34px 0 rgba(0,0,0,0.11);
	font-weight: bold;
	display: inline-block;
	font-size: ${CONSTANTS.h2};
	pointer-events: none;
	text-align: center;
	color: ${props => {
		switch(props.color) {
			case "green":
				return CONSTANTS.green;
			case "yellow":
				return CONSTANTS.yellow;
			default:
				return CONSTANTS.primary;
			}
		}};
	> div {
		position: relative;
		width: 100%;
		height: 100%;
		span {
			position: absolute;
	    width: 100%;
	    top: -100%;
			display: flex;
			justify-content: center;
		}
	}
	&.one {
		position: absolute;
		font-size: ${CONSTANTS.display1};
		border-radius: 32px;
		padding: 2.7rem;
		transform: rotate(-5deg);
		top: 310px;
		left: 30px;
	}
	&.two {
		position: absolute;
		font-size: ${CONSTANTS.display2};
		padding: 3rem;
		padding: 2rem;
		border-radius: 26px;
		top: 170px;
		left: 250px;
		transform: rotate(12deg);
		span { top: -115%}
	}
	&.three {
		position: absolute;
		font-size: ${CONSTANTS.h2};
		top: 120px;
		transform: rotate(-9deg);
		span { top: -130%}
	}
`;

const MiniTile = styled.div`
	background: ${CONSTANTS.bordergrey};
	border-radius: 10px;
	padding: .8rem;
	font-weight: bold;
	color: ${CONSTANTS.background};
	font-size: 24px;
	position: absolute;
	pointer-events: none;
	&.one {
		transform: rotate(12deg);
		left: 150px;
		top: 120px;
	}
	&.two {
		top: 340px;
		transform: rotate(21deg);
		left: 242px;
	}
	&.three {
		top: 250px;
		left: -60px;
		transform: rotate(-18deg);
	}
`;

const InfoTile = styled.div`
  margin: 4rem 0 2rem 0;
	text-align: center;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	.shadow {
		width: 81px;
		height: 14px;
		border-radius: 50%;
		background: #F1F8FC;
		margin: 0 auto;
		margin-bottom: 1rem;
	}
	img {

		margin: 3rem 0 2rem 0;
	}
	span {
		font-size: ${CONSTANTS.h3};
		color: ${CONSTANTS.primary};
		&.yellow {
			color: ${CONSTANTS.yellow};
		}
	}
`;
const InfoSection = styled.section`
	width: 100%;
	padding: 2rem 0 6rem 0;
	text-align: center;
	> div {
		display: flex;
		justify-content: space-around;
	}
	> p {
		color: ${CONSTANTS.darkergrey};
		line-height: 1.8rem;
		font-size: ${CONSTANTS.body};
		font-weight: 500;
		&:first-child{
			margin-top: 4rem;
		}
	}
	border-bottom: 3px solid ${CONSTANTS.bordergrey};
	button {
		margin: 2rem auto;
	}
`;

const IconButton = styled.button`
	display: flex;
	align-items: center;
	position: relative;
	vertical-align: middle;
	flex-direction: row;
	p { 
		display: block; 
		line-height: 28px;
	}
	transition: all .15s ease-out;
	img { 
		position: absolute;
		transition: all 300ms cubic-bezier(0.535, 0.000, 0.385, 1.345);
		left: 4px;
	 }
	> div {
		position: relative;
		width: 32px;
		height: 32px;
	}
	&:hover {
		img {
			left: 8px;
		}
	}
`;

class LandingPage extends Component{
	render(){
		return(
			<div>
				<HeroSection>
					<div className='title-section'>
							<h1>Booli</h1>
							<span>Learn Korean through its roots</span>
							<Link to={"/menu/"}>
								<IconButton>
									<p>Start Learning</p> 
									<div>
										<img src={require('../assets/arrow.svg')} alt='Crown' />
									</div>
								</IconButton>
							</Link>
					</div>
					<div className='banner-section hide-mob'>
						<LetterTile className="one"><div>한<span>Korea</span></div></LetterTile>
						<LetterTile color="yellow" className="two"><div>어<span>Language</span></div></LetterTile>
						<LetterTile color="green" className="three"><div>교<span>School</span></div></LetterTile>
						<MiniTile className="one">신</MiniTile>
						<MiniTile className="two">국</MiniTile>
						<MiniTile className="three">남</MiniTile>
					</div>
				</HeroSection>
				<BgImg src={require('../assets/home_background.svg')} alt='Background' />
				<InfoSection>
					<div>
						<InfoTile>
							<div>
								<LetterTile><div>여</div></LetterTile>
							</div>
								<img src={require('../assets/woman.svg')} alt='Woman' />
							<div className="shadow" />
							<span>Woman</span>
						</InfoTile>
						<InfoTile>
							<div>
								<LetterTile color="yellow">왕</LetterTile>
							</div>
								<img src={require('../assets/crown.svg')} alt='Crown' />
							<div className="shadow" />
							<span className="yellow">King</span>
						</InfoTile>
					</div>
					<p>Learn core hanja syllables <br/>
					to easily memorise Korean words</p>
				</InfoSection>
				<InfoSection>
					<div>
						<InfoTile>
							<div>
								<LetterTile><div>여왕</div></LetterTile>
							</div>
							<img src={require('../assets/queen.svg')} alt='Queen' />
							<div className="shadow" />
							<span>Queen</span>
						</InfoTile>
					</div>
					<p>Recognize new words <br/>
						without needing translation</p>
				</InfoSection>
				<InfoSection>
					<p>The most effective way <br/>
						to learn Korean vocabulary</p>
					<Link to={"/menu/"}>
						<IconButton>
							<p>Start Learning</p> 
							<div>
								<img src={require('../assets/arrow.svg')} alt='Crown' />
							</div>
						</IconButton>
					</Link>
					<Copyright />
				</InfoSection>
				
			</div>
		)
	}
}


export default LandingPage;



// WEBPACK FOOTER //
// ./src/components/landingpage.js